import PropTypes from "prop-types";
import { withAuthGuard } from "src/hocs/with-auth-guard";
import { useAuth } from "src/hooks/use-auth";
import { useSettings } from "src/hooks/use-settings";
import { useSections } from "./config";
import { HorizontalLayout } from "./horizontal-layout";
import { VerticalLayout } from "./vertical-layout";
import { useInitialize } from "src/hooks/use-initialize";
import { useLocation } from "react-router-dom";
import { saveLastDashboardRoute } from "./last-dashboard-route";
import { useEffect } from "react";

export const Layout = withAuthGuard((props) => {
  const { rememberRoute = true } = props;
  const settings = useSettings();
  let sections = useSections();
  const { user } = useAuth();
  const location = useLocation();
  // TODO: display load when is not initialized
  useInitialize();

  // 탭 query까지 포함해 사용자가 마지막으로 본 일반 대시보드 메뉴를 기억한다.
  useEffect(() => {
    if (!user || !rememberRoute) return;
    saveLastDashboardRoute(`${location.pathname}${location.search}`, user);
  }, [location.pathname, location.search, user, rememberRoute]);

  if (user && !user.isAdmin) {
    sections = sections.filter((section) => !section.admin);
  }

  if (settings.layout === "horizontal") {
    return (
      <HorizontalLayout
        sections={sections}
        navColor={settings.navColor}
        {...props}
      />
    );
  }

  return (
    <VerticalLayout
      sections={sections}
      navColor={settings.navColor}
      {...props}
    />
  );
});

Layout.propTypes = {
  children: PropTypes.node,
  rememberRoute: PropTypes.bool,
  forceMenu: PropTypes.bool,
};
